import pick from 'lodash/pick';
import { getFormValues } from 'redux-form';
import { CannedQuestionName } from '../../api/models/survey';
import { CHECKOUT_FORM_NAME } from '../../constants';
import { getIsNosSourceOfTruth } from '../../selectors/event';
import { getAnswersForQuestionsAffectingQuebecQSTTaxes } from '../../selectors/forms';
import { getSurvey } from '../../selectors/survey';
import { CheckoutState } from '../../state';

export const getFormDataForTaxExemption = (state: CheckoutState) => {
    const formValues = getFormValues(CHECKOUT_FORM_NAME)(state);
    const {
        hasQuebecQSTTaxQuestion,
        prePaymentSurveySettings: { getCleanedFormData },
    } = getSurvey(state);

    const formDataForTaxExemption = getCleanedFormData(formValues);

    if (!formDataForTaxExemption.buyer) {
        return formDataForTaxExemption;
    }

    // Removing all buyer questions but tax related only on LOS flow
    // TODO EB-252410: Temporary fix to enable attendees to purchase on Quebec events on NOS
    // This should be removed once OS (EB-252408) has resolved the mentioned ticket on the BE.
    if (!getIsNosSourceOfTruth(state)) {
        formDataForTaxExemption.buyer = pick(formDataForTaxExemption.buyer, [
            CannedQuestionName.isBusiness,
            CannedQuestionName.taxRegistrationId,
            CannedQuestionName.businessTaxAddress,
        ]);
    }

    // Only in Quebec QST we have to send the billing zipcode as it's used to tell whether buyer is from Quebec
    // (and should be charged) or not
    if (hasQuebecQSTTaxQuestion) {
        const answers = getAnswersForQuestionsAffectingQuebecQSTTaxes(
            formValues,
            state,
        );

        return {
            ...formDataForTaxExemption,
            buyer: { ...formDataForTaxExemption.buyer, ...answers },
        };
    }

    return formDataForTaxExemption;
};
